<div *ngIf="showInfoTooltip">
    <div
        class="tw-absolute tw-bottom-[110%] tw-left-[0] tw-z-10 tw-w-[100%] tw-bg-white tw-rounded-xl tw-border-2 tw-border-solid tw-border-caption-gray tw-border-opacity-25 box-shadow"
    >
        <div class="tw-relative">
            <div>
                <div
                    class="tw-px-[25px] tw-py-[21px] tw-text-[18px] tw-text-black tw-font-semibold tw-border-b-2 tw-border-solid tw-border-caption-gray tw-border-opacity-25"
                >
                    {{ tooltipData.header | translate }}
                </div>
                <div
                    class="tw-px-[25px] tw-py-[21px] tw-text-[14px] lg:tw-text-[12px] xl:tw-text-[16px] tw-text-caption-gray"
                >
                    {{ tooltipData.content | translate }}
                    <div *ngIf="tooltipData.content2">
                        {{ tooltipData.content2 | translate }}
                    </div>
                    <div *ngIf="tooltipData.content3">
                        {{ tooltipData.content3 | translate }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
